import { ready } from "./lib/dom";
import { blockedElemId } from "./lib/block-detection";

ready(() => {
  const e = document.createElement('meta');
  e.id = blockedElemId;
  document.head.appendChild(e);
});
